/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const authState = {
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    token: null,
    organization: null,
};

